import ModalCustom from "components/ModalCustom"
import ActionFooterModalCard from "components/ModalCustom/ActionFooterModalCard"
import { useEffect, useState } from "react"
import { closeModal, openModal } from "reducers/modal"
import { configureStore } from "stores/configureStore"
import {
  addRoleGroupOrganizationMiddleware,
  getProjectSyncOrganizationsMiddleware,
  handleUserShareKeyProjectMiddleware,
  moveProjectToOrganizationMiddleware,
} from "../services/api"
import { toast } from "react-toastify"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { getUserMiddleware } from "pages/auth/services/api"
import FormInputCard from "pages/auth/molecules/FormInputCard"
import SelectMulti from "components/Select/SelectMulti"

interface MoveToOrganizationModalProps {
  isOpen: boolean
  onClose: () => void
  projectId: string
  projectName: string
  callback: () => void
}

export const MoveToOrganizationModal = (
  props: MoveToOrganizationModalProps
) => {
  const { onClose, projectId, projectName, callback, isOpen } = props
  const [sourceOrganizations, setSourceOrganizations] = useState<
    {
      label: string
      value: string
      db_name: string
    }[]
  >([])
  const [selectedOrganization, setSelectedOrganization] = useState<{
    label: string
    value: string
    db_name: string
  }>({
    label: "",
    value: "",
    db_name: "",
  })
  useEffect(() => {
    if (!projectId || !isOpen) {
      return
    }
    fetchOrganizations()
  }, [projectId, isOpen])

  const fetchOrganizations = async () => {
    try {
      const response = await getProjectSyncOrganizationsMiddleware(projectId)
      if (response.data.organizations.length) {
        const newOrganizations = response.data.organizations.map((el) => ({
          label: el.name,
          value: el.id,
          db_name: el.db_name,
        }))
        setSourceOrganizations(newOrganizations)
      }
    } catch (err: any) {
      console.log(err)
    }
  }

  const onSubmit = () => {
    configureStore.dispatch(
      openModal({
        type: "Delete",
        props: {
          deleteModal: {
            title: (
              <p>
                This will transfer the entire project{" "}
                <span className="font-bold">{projectName}</span> (including its
                components, builds, and conversations) to the Workspace{" "}
                <span className="font-bold">{selectedOrganization.label}</span>.
                The project will be permanently removed from your Personal
                workspace.
              </p>
            ),
            label: `Warning`,
            content: `This action cannot be undone.`,
            onSubmit: async () => {
              try {
                await moveProjectToOrganizationMiddleware(
                  projectId,
                  selectedOrganization.value
                )
                await handleUserShareKeyProjectMiddleware(
                  true,
                  false,
                  JSON.stringify([projectId]),
                  undefined,
                  undefined,
                  selectedOrganization.db_name
                )
                await addRoleGroupOrganizationMiddleware({
                  is_share_all_project: true,
                  project_ids: JSON.stringify([projectId]),
                  dbName: selectedOrganization.db_name,
                })
                getUserMiddleware()
                closeModal()
                onClose()
                callback()
                toast(
                  <LabelNotificationPage
                    messenger="Move project to workspace successfully!"
                    type="success"
                  />
                )
              } catch (error: any) {
                closeModal()
                toast(
                  <LabelNotificationPage
                    messenger={
                      error?.response?.data?.message ||
                      "Move project to workspace failed!"
                    }
                    type="error"
                  />
                )
              }
            },
            styleTitle: { textAlign: "center" },
            titleButton: "Yes, Move Project",
            colorYellowButton: true,
          },
        },
      })
    )
  }

  return (
    <ModalCustom
      label="Move to Workspace"
      widthModal={500}
      handleChangeButton={() => onClose}
      bodyChildren={
        <div className="flex flex-col">
          <div className="grid grid-cols-1 gap-2 mb-[24px]">
            <FormInputCard title="Workspace" fontWeightText="font-semibold">
              <SelectMulti
                options={sourceOrganizations}
                selectedOption={selectedOrganization}
                handleChange={(changedData) => {
                  setSelectedOrganization(changedData)
                }}
                isMulti={false}
                noOptionsMessage
              />
            </FormInputCard>
          </div>
          <ActionFooterModalCard
            onCloseModal={onClose}
            onSubmit={onSubmit}
            handleDisableButton={!selectedOrganization.value}
            titleButton="Move"
          />
        </div>
      }
    />
  )
}
